import {
    IMPERSONATION_RESET_STATE,
    IMPERSONATION_SET_STATE,
} from "./actionType";

const INIT_STATE = {
    isImpersonating: false,
    originalUser: null,
    activeUser: null,
};

const ImpersonationReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case IMPERSONATION_SET_STATE:
            return {
                ...state,
                ...action.payload,
            };

        case IMPERSONATION_RESET_STATE:
            return {
                ...INIT_STATE,
            };

        default:
            return state;
    }
};

export default ImpersonationReducer;
